import { Button } from 'blaze-ui/Button'
import Styles from './AutopilotProUpgradeButton.module.scss'
import cx from 'classnames'
import LockOpen3 from 'blaze-ui/icons/24/LockOpen3'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { useModals } from 'almanac-ui/Modal'
import { AutopilotUpgradeEntryModal } from 'components/AutopilotUpgradeEntryModal/AutopilotUpgradeEntryModal'
import { OpenAutopilotUpgradeOptions } from 'hooks/useOpenAutopilotUpgrade'
import { ButtonProps } from 'blaze-ui/Button/Types'

interface AutopilotProUpgradeButtonProps
  extends Omit<ButtonProps, 'onPress' | 'color' | 'children' | 'variant' | 'frontIcon' | 'endIcon'> {
  className?: string
  variant?: 'pro' | 'upgrade' | ButtonProps['variant']
  children?: React.ReactNode
  options?: OpenAutopilotUpgradeOptions
}

export const AutopilotProUpgradeButton = ({
  className,
  variant = 'pro',
  children,
  options,
  ...buttonProps
}: AutopilotProUpgradeButtonProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { openModal } = useModals()

  if (isSystemRedesignEnabled) {
    return (
      <Button
        onPress={() => openModal(AutopilotUpgradeEntryModal, {}, options)}
        frontIcon={LockOpen3}
        color="var(--upgrade)"
        variant="secondary"
        {...buttonProps}
      >
        Upgrade
      </Button>
    )
  }

  return (
    <Button
      frontIcon={LockOpen3}
      onPress={() => openModal(AutopilotUpgradeEntryModal, {}, options)}
      className={cx(Styles.upgradeButton, className, Styles[variant])}
      color="#6A00FF"
      {...buttonProps}
    >
      {children ?? 'Upgrade'}
    </Button>
  )
}
